import React from 'react';

import { useAppConnectionBannerActions } from '../../../controllers/app-connection-banner-store/useAppConnectionBannerActions';

import { AppConnectionBanner, type UnconnectedApp } from './index';

// In the connected-state variant each row derives its Connect/Connected state
// from the connectors store (`isUserOAuthed`), so there is nothing to do on a
// successful connect here. A stable module-level no-op satisfies the required
// prop without changing identity per render (which would churn the row's OAuth
// handler memo).
const noop = () => {};

/**
 * Renders the 3P suggested-prompts connection prompt inline in the chat thread
 * (CCINT-8723). chat-history owns *when* and *which apps* — it latches the apps
 * per conversation (mirroring `StoreConnectorRecommendation`) and passes the
 * pinned list here, so the prompt survives new messages without depending on the
 * transient app-connection-banner store. Each row's Connect/Connected state is
 * still read live from the connectors store inside `AppConnectionBanner`.
 */
export const InThreadAppConnectionPrompt = ({
	apps,
}: {
	apps: UnconnectedApp[];
}): React.JSX.Element | null => {
	const { hideBanner } = useAppConnectionBannerActions();

	if (apps.length === 0) {
		return null;
	}

	return (
		<AppConnectionBanner
			unconnectedApps={apps}
			showConnectedState
			onConnect={noop}
			onDismiss={hideBanner}
		/>
	);
};
